<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TufOiz/tc-custom/9781772124330.jpg?1703426610246" alt="This image is the cover for the book Sam Steele"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sam Steele
      </h1>
      <p class="bookDescription body article font2">
        <b>The life of Canada’s police and military hero is “a story worth telling. Macleod’s solid research and clear writing also make it a story worth reading” (<i>AlbertaPrimeTimes.com</i>).</b><br/><br/> Sam Steele, “the man who tamed the Gold Rush,” had a high-profile public career, yet his private life has been closely protected. This biography follows Steele’s rise from farm boy in backwoods Ontario to the much-lauded Major General Sir Samuel Benfield Steele. Drawing on the vast Steele archive at the University of Alberta, this comprehensive biography vividly recounts some of the most significant events of the first fifty years of Canadian Confederation—including the founding of the North-West Mounted Police, the opening of the North through the Klondike, and Canada’s participation in the South African War—from the perspective of a policeman who became a military leader. Impeccably researched and accessibly written, Sam Steele is perfect for anyone interested in Canada’s early decades.<br/><br/><b>“Deeply-researched and elegantly written, this book brings alive one of the most intriguing characters of Canadian history who has been undeservedly forgotten.” —Charlotte Gray, bestselling author of <i>Murdered Midas</i> </b><br/><br/><b>“A revealing story of a talented, dedicated Canadian who always strove to do his best for his country.” —<i>Canadian Military History</i></b><br/><br/><b>“Focusing on its subject’s life and career, <i>Sam Steele</i> paints a thoughtful portrait of an interesting and important man that, like any good book, raises interesting and important questions . . . this biography is likely to remain the definitive work on Steele’s life.” —<i>Canadian Historical Review</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rod Macleod
      </h2>
      
      <p class="authorDescription body article">Rod Macleod, Professor Emeritus, was professor of History and Classics at the University of Alberta from 1969 until he retired in 2005. During his tenure he served as Chair of the Department of History and later as Associate Dean of Arts. He has written extensively on the history of Western Canada as well as Canadian legal and military history. His books include The Mounties and Prairie Fire: The 1885 North West Rebellion as well as The North West Mounted Police and Law Enforcement 1873-1905. Rod is the official historian for the University of Alberta. In that capacity he researched and wrote All True Things: A History of the University of Alberta, 1908 – 2008, published by the University of Alberta Press. He served two terms as the Alberta representative on the Historic Sites and Monuments Board of Canada. Rod Macleod lives in Edmonton.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Alberta Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d2eaf1f